import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"

function FilterRemoveButton({ filter, className }) {
    return (
        <button
            className={`ns-act-btn ns-text-align-right ns-align-items-center ns-clickable ns-color-black ${className} ns-remove-filter-btn`}
            onClick={() => filter.remove()}
        >
            <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 5L19 19M19 5L5 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>
            </svg>
        </button>
    )
}

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters()

    return (
        filters.length > 0 && (
            // ns-pl-2 ns-pr-2 ns-pt-2 ns-pb-2
            <div class="ns-d-flex ns-flex-wrap ns-align-items-center ns-selected-filters-wrapper">
                {/* ns-col-10 */}
                <div class="ns-d-flex ns-flex-wrap ns-align-items-center ns-selected-filters-container">
                    {filters.map(filter => (
                        <div
                            key={`${filter.name}: ${filter.value}`}
                            // ns-px-1
                            class="ns-selected-filter ns-d-flex ns-align-items-center ns-mr-1 ns-mb-1"
                        >
                            <span class="ns-color-black">
                                {filter.value === "InStock" ? "In stock" : filter.value === "OutOfStock" ? "Out of stock" : filter.value}
                            </span>
                            <FilterRemoveButton filter={filter} />
                        </div>
                    ))}
                </div>
                {/* <span
                    class="ns-anchor ns-col-2 ns-text-align-right ns-color-link ns-font-4 ns-ml-2 ns-mr-0 ns-ml-auto"
                    onClick={() => {
                        removeAll()
                    }}
                >
                    Clear Filters
                </span> */}
            </div>
        )
    )
}
